import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-upload',
  templateUrl: './upload.component.html',
})
export class UploadComponent {
  public profileForm = new FormGroup({
    name: new FormControl(''),
    // photo: new FormControl(''),
  });

  onSubmit() {
    // TODO: Use EventEmitter with form value
    console.warn(this.profileForm.value);
  }
}
